module.exports = __webpack_public_path__ + "static/media/cardAgent_active.bbd9378b.svg";